module.exports = __webpack_public_path__ + "img/emoji_018.b9e47ab1.png";